import { useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import { cents } from "../lib/api";

export const StickyCheckoutBar = () => {
  const { count, bundle } = useCart();
  const navigate = useNavigate();
  if (count === 0) return null;
  return (
    <>
      <div className="h-20 md:hidden" aria-hidden="true" />
      <div data-testid="sticky-checkout-bar"
        className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-[#171715] text-[#FBF6F1] px-4 py-3 pb-[max(0.75rem,env(safe-area-inset-bottom))] flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-medium">{count} bottle{count === 1 ? "" : "s"}</p>
          <p data-testid="sticky-checkout-total" className="font-mono text-sm">{bundle ? cents(bundle.cents) : ""}</p>
        </div>
        <button data-testid="sticky-checkout-button"
          className="bg-[#FBF6F1] text-[#171715] px-5 min-h-[44px] font-semibold shrink-0"
          onClick={() => navigate("/cart")}>
          Review &amp; checkout
        </button>
      </div>
    </>
  );
};
